import { render } from "./HotspotButton.vue?vue&type=template&id=4841def8"
import script from "./HotspotButton.vue?vue&type=script&lang=js"
export * from "./HotspotButton.vue?vue&type=script&lang=js"

import "./HotspotButton.vue?vue&type=style&index=0&id=4841def8&lang=css"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__